import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';

export function DifficultySelector({ onChange }) {
  const techStacks = [
    'Easy', 'Medium', 'Hard', 'Very Hard'
  ]; // List of tech stacks

  return (
    <div className={cn("space-y-2")}>
      <Label htmlFor="tech-stack-select">Select Difficulty:</Label>
      <Select onValueChange={onChange} required>
        <SelectTrigger id="tech-stack-select" className="w-full">
          <SelectValue placeholder="Select Difficulty" />
        </SelectTrigger>
        <SelectContent>
          {techStacks.map((stack, index) => (
            <SelectItem key={index} value={stack}>
              {stack}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}